// Mostek nakładki planera ↔ widżet czatu OPTISOFA. Zastępuje assets/planner-overlay-chat.js motywu, który łączył
// planer z Gorgiasem. Protokół postMessage bez zmian (planner:chat:hello / mounted / open → state / opened / closed /
// unavailable), więc kodu planera (iframe na Railway) nie trzeba zmieniać.
(() => {
  const origin = 'https://config.optisofa.com';   // the planner's domain since 27.10 (as assets/planner-overlay-chat.js)
  const getFrame = () => document.querySelector('.optisofa-planner-overlay shopify-overlay-planner-helper iframe');
  const active = () => { try { return new URL(getFrame().src).origin === origin; } catch { return false; } };
  let chat = null, mounted = false, requested = false, childReady = false;

  const send = (type, detail = {}) => { if (active() && childReady) getFrame().contentWindow?.postMessage({ type, ...detail }, origin); };
  const state = () => send('planner:chat:state', { ready: !!chat, unread: chat ? chat.unread() : 0 });
  const release = () => {
    // Planer zamknięty – nasz przycisk czatu wraca na swoje miejsce.
    if (mounted && chat) { chat.setLauncherHidden(false); chat.setOnTop(false); }
    mounted = false; requested = false;
  };

  function connect() {
    if (chat || !window.OptisofaChat) return;
    chat = window.OptisofaChat;
    chat.on('unread', state);
    chat.on('opened', () => { if (mounted && requested) send('planner:chat:opened'); });
    chat.on('closed', () => { if (requested) { requested = false; send('planner:chat:closed'); } });
    state();
  }

  window.addEventListener('message', (event) => {
    if (!active() || event.source !== getFrame().contentWindow || event.origin !== origin) return;
    switch (event.data?.type) {
      case 'planner:chat:hello': childReady = true; connect(); state(); break;
      case 'planner:chat:mounted':
        // Planer ma własny przycisk czatu – chowamy nasz i wynosimy panel nad nakładkę.
        if (chat) { mounted = true; chat.setLauncherHidden(true); chat.setOnTop(true); }
        break;
      case 'planner:chat:open':
        if (!chat || !mounted) { send('planner:chat:unavailable'); return; }
        requested = true;
        chat.open();
        break;
    }
  });
  window.addEventListener('optisofa-chat:ready', () => { connect(); state(); });
  // Nakładka planera usunięta z DOM → przywróć widżet.
  new MutationObserver(() => { if (mounted && !getFrame()) release(); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('pageshow', () => { connect(); state(); });
  connect();
})();
